import { format } from 'date-fns';

import fr from 'date-fns/locale/fr';

const useDateFormat = () => {
  const overloadFormat: typeof format = (date, token, options = {}) => {
    return format(date, token, { ...options, locale: fr });
  };
  return overloadFormat;
};

export default useDateFormat;
